import { render, staticRenderFns } from "./RecobroConfig.vue?vue&type=template&id=57a70d40"
import script from "./RecobroConfig.vue?vue&type=script&lang=js"
export * from "./RecobroConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports